import { Box, Grid, LinearProgress, Typography } from '@mui/material';
import React from 'react'

type Props = {
  progress: number
}

const LinearProgressWithLabel = ({ progress }: Props) => {

  if (progress < 0) {
    progress = 0;
  }


  if (progress > 100) {
    progress = 100;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', p: 1 }}>
      <Grid item flex={'1'}>
        <LinearProgress variant="determinate" color='info' value={progress} sx={{ height: '8px' }} />
      </Grid>
      <Grid item sx={{ pl: 1, minWidth:'48px' }}>
        <Typography color="text.secondary">{`${Math.round(
          progress,
        )}%`}</Typography>
      </Grid>
    </Box>
  );
}

export default LinearProgressWithLabel